import ActionSheet from 'antd-mobile/lib/action-sheet';
export default ActionSheet;



// WEBPACK FOOTER //
// ./components/action-sheet/index.tsx